var $name="getCSSVariable",$path="app/utilities/getCSSVariable.js",$this={$name,$path,};import validateCSSVariable from './validateCSSVariable';

function getCSSVariable(name, element = document.documentElement) {
  validateCSSVariable(name);
  return getComputedStyle(element).getPropertyValue(name);
}

export default getCSSVariable;
